import { put } from 'redux-saga/effects';
import { history } from '../rootStore';
import { errorsActions } from './actions';

export function* showApiError(e?: Error) {
  yield put(errorsActions.showApiError({ path: history.location.pathname, message: e?.message }));
}
